export const provinceOptions = [
  { value: 'ontario', label: 'Ontario' },
  { value: 'alberta', label: 'Alberta' },
  { value: 'british-columbia', label: 'British Columbia' },
]
